module.exports = __webpack_public_path__ + "static/media/logo_it@2x.a96260b5.png";